import React from 'react'
import InputFormContainer from '../../Atoms/InputFormContainer/InputFormContainer'
import { Form, Select, Switch, DatePicker} from 'antd'
import FormTitle from '../../Atoms/FormTitle/FormTitle'
const { Option } = Select;

const StartEndAndFrequency = () => {

  const [form] = Form.useForm();

  const sendForm = (e) => {
    console.log(e); // Aqui el objeto con los valores del formulario
  };

  const onChangeChecked = (checked) => {
    console.log(`switch to ${checked}`);
  }

  const onChange = (e) => {
    console.log(e); 
  };

  return (
    <div className="box s-pxy-20 m-pxy-50 mt-30">
      <p className="source-24 mb-20">Inicio, finalización y frecuencia:</p>

      <Form onFinish={sendForm} form={form} >
        <div className="nd-grid m-grid-2">

          <InputFormContainer label="Fecha de inicio:" indentificador="initDate" >
            <Form.Item name="initDate" rules={[{required: true, message: "Debe indicar la fecha de inicio"}]}>
              <DatePicker size="large" placeholder="Fecha de inicio" onChange={onChange} />
            </Form.Item>
          </InputFormContainer>

          <InputFormContainer label="Hora de inicio:" indentificador="initHour">
            <Form.Item name="initHour" rules={[{required: true, message: "Debe indicar la hora de inicio"}]}>
              <input type="time" placeholder="Hora de inicio"  />
            </Form.Item>
          </InputFormContainer>

          <InputFormContainer label="Fecha de finalización:" indentificador="finalitationDate">
            <Form.Item name="finalitationDate" rules={[{required: true, message: "Debe indicar la fecha de finalización:"}]}>
              <DatePicker size="large" placeholder="Fecha de finalización" onChange={onChange} />
            </Form.Item>
          </InputFormContainer>

          <InputFormContainer label="Hora de finalización:" indentificador="finalitationHour">
            <Form.Item name="finalitationHour" rules={[{required: true, message: "Debe indicar la hora de finalización:"}]}>
              <input type="time" placeholder="Hora de inicio"  />
            </Form.Item>
          </InputFormContainer>

          <div className="m-cols-2">
            <InputFormContainer label="Frecuencia de la campaña:" indentificador="frecuence">
              <Form.Item name="frecuence" rules={[{required: true, message: "Frecuencia de la campaña::"}]}>
                <Select size="large" placeholder="Frecuencia de la campaña:">
                  <Option value="Frecuencia de la campaña: ">Repetir diariamente</Option>
                </Select>
              </Form.Item>
            </InputFormContainer>
          </div>

          <FormTitle text="Asignación de perfiles de operadores" />
        
          <div className="assing-profile_content m-cols-2">
            <div className="assing-profile_info">
              <div className="assing-profile_info_cols1">
                <p className="source-16 sm-bold mb-10">Cantidad de agentes inteligentes</p>
                <p className="source-16 mb-15">IA creada y administrada por Geniux.</p>
                <InputFormContainer indentificador="cost-agent">
                  <Form.Item name="cost-agent" rules={[{required: true, message: "Agente"}]}>
                    <Select size="large" placeholder="01 Agente IA - Costo 05usd / día">
                      <Option value="05usd">01 Agente IA - Costo 05usd / día</Option>
                    </Select>
                  </Form.Item>
                </InputFormContainer>
              </div>
              <div  className="assing-profile_info_cols2">
                <Switch defaultChecked onChange={onChangeChecked} />
              </div>
            </div>

            <div className="assing-profile_info mt-20 mb-30">
              <div className="assing-profile_info_cols1">
                <p className="source-16 sm-bold mb-10">Agentes Externos</p>
                <p className="source-16 mb-15">Perfiles de empleados o colaboradores que forman parte de tu equipo</p>
              </div>
              <div  className="assing-profile_info_cols2">
                <Switch defaultChecked onChange={onChangeChecked} />
              </div>
            </div>

            <InputFormContainer spanTwo label="Selecciona uno o más perfiles para esta campaña:" indentificador="profiles">
              <Form.Item name="profiles" rules={[{ required: true, message: "Selecciona uno o más perfiles" }]} >
                <Select placeholder="Selecciona uno o más perfiles para esta campaña:" mode="multiple" size="large">
                  <Select.Option value="José Antonio Martinez" key={1} >
                    José Antonio Martinez
                  </Select.Option>
                  <Select.Option value="Andrea Pereira" key={2}>
                    Andrea Pereira
                  </Select.Option>
                  <Select.Option value="Armando Petroccelli" key={3} >
                    Armando Petroccelli
                  </Select.Option>
                </Select>
              </Form.Item>
            </InputFormContainer>
          </div>
        </div>
      </Form>
    </div>
  )
}

export default StartEndAndFrequency
